@if (!hideSummary) {
  <div class="questionnaire-summary">
    <div class="header">Questionnaire Summary</div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Application #:</div>
      <div class="ml-2">{{ questionnaireSummary.appNumber }}</div>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Applicant:</div>
      <div class="ml-2">{{ questionnaireSummary.firmName }}</div>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Contact Person:</div>
      <div class="ml-2">{{ questionnaireSummary.contactPerson }}</div>
    </div>
    <div class="flex questionnaire-summary-item gap-2">
      <div class="summary-title">Phone Number:</div>
      <p id="phone-number-value">
        {{ questionnaireSummary.contactPhone | mask: '(999) 999-9999' }}
      </p>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Email Address:</div>
      <div class="ml-2">{{ questionnaireSummary.contactEmail }}</div>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Bonding Capacity:</div>
      <div class="ml-2">{{ questionnaireSummary.bondingCapacity | currency }}</div>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Min Gross Revenue:</div>
      <div class="ml-2">{{ questionnaireSummary.minGrossRevenue | currency }}</div>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Max Gross Revenue:</div>
      <div class="ml-2">{{ questionnaireSummary.maxGrossRevenue | currency }}</div>
    </div>
    <div class="flex questionnaire-summary-item">
      <div class="summary-title">Avg. Gross Revenue:</div>
      <div class="ml-2">{{ questionnaireSummary.averageGrossRevenue | currency }}</div>
    </div>
  </div>
}
